<div class="container py-2">
    <ng-container *ngIf="anmeldungenAktiv">
        <h3>Vielen Dank für Ihre Anmeldung!</h3>
        <p>
            Sie haben Ihr Kind erfolgreich für die gewünschten Aktionen angemeldet. Das T.o.J.-Team wird alle
            Anmeldungen
            zeitnah prüfen. Sobald die Prüfung abgeschlossen ist, erhalten Sie eine Anmeldebestätigung per E-Mail. Darin
            erfahren Sie, für welche Aktionen Ihr Kind verbindlich angemeldet ist und bei welchen Aktionen es ggf. einen
            Platz auf der Warteliste erhalten hat. <br><br>
            Bitte überweisen Sie erst nach der Bestätigung den fälligen Teilnahmebetrag innerhalb von 3 Werktagen, um
            den Platz verbindlich zu sichern. Ohne fristgerechte Zahlung wird der Platz automatisch weitervergeben.
        </p>
    </ng-container>
    <ng-container *ngIf="!anmeldungenAktiv">
        <h3>Voranmeldung abgeschlossen!</h3>
        <p>
            Sie haben Ihre Kinder erfolgreich zu den gewünschten Aktionen <b>vorangemeldet</b>.
            Ab dem <b>{{ anmeldungenDatum | datum }} um {{ anmeldungenDatum | zeit }}</b> können Sie die Voranmeldungen
            verbindlich an das T.o.J.-Team übermitteln. 24 Stunden vorher sehen Sie hier einen Timer. Sobald dieser
            Timer abgelaufen ist, erscheint ein Button „Kinder anmelden“ mit dem Sie die Voranmeldungen an das
            T.o.J.-Team übermitteln können.<br><br>
            Nach Eingang Ihrer finalen Anmeldung wird das T.o.J.-Team alle Anfragen prüfen. Anschließend erhalten Sie
            eine <b>Bestätigungs-E-Mail</b> mit den Informationen, für welche Aktionen Ihre Kinder verbindlich gebucht
            sind. Bedenken Sie bitte das uns sehr viele Buchungen erreichen. Bis die Bestätigungs-E-Mail kommt, kann es
            also einen Moment dauern.<br><br>
            <b>Bitte beachten:</b> Erst mit dem Erhalt dieser E-Mail ist die Teilnahme gesichert.
        </p>
    </ng-container>

    <table class="table">
        <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Vorangemeldet</th>
            <th>Angemeldet</th>
            <th>Warteliste</th>
            <th>Gebucht</th>
            <th></th>
        </tr>
        <tr *ngFor="let k of kinder">
            <td>{{ k.id }}</td>
            <td>{{ k.vorname }}</td>
            <ng-container *ngIf="getAnmeldungenList(k) as list">
                <td>{{ list.vorangemeldet }}</td>
                <td>{{ list.angemeldet }}</td>
                <td>{{ list.warteliste }}</td>
                <td>{{ list.gebucht }}</td>
                <td>
                    <button *ngIf="list.angemeldet > 0" class="btn pcButton" ngbTooltip="Anmeldung downloaden" (click)="download(k)"><i
                            class="fas fa-download"></i></button>
                </td>
            </ng-container>
        </tr>
    </table>

</div>
